import React from 'react'
import { Header } from '../styles'


export default function Head() {
    return (
        <Header>
            <h1>Freshkeeper</h1>
        </Header>
    )
}